<template src="./template.html"></template>

<script>
import CityAreaData from '@/common/city_area_data'
import DataValid from '@/common/data_valid'
export default {
  name: "UserDataForm",
  props: {
    value: {
      require: true,
      type: Object
    },
    show: {
      require: true,
      type: Boolean
    }
  },
  mixins: [CityAreaData, DataValid],
  data() {
    return {
      errors: [],
      shop_list: []
    }
  },
  methods: {
    CityChange() {
      this.form_data.area = ''
    },
    ChangeData(key, value) {
      let tmp_data = Object.assign({}, this.value)
      tmp_data[key] = value
      this.$emit("input", tmp_data)
    },
    GetError(key) {
      let error = this.errors.filter((item) => item.type == key)
      return error.length > 0 ? error[0].text : ""
    },
    UserDataValid() {
      this.errors = []
      if (this.validEmail(this.value.email) != true) {
        this.errors.push({
          type: "email",
          text: this.validEmail(this.value.email)
        })
      }
      if (this.validPhone(this.value.phone) != true) {
        this.errors.push({
          type: "phone",
          text: this.validPhone(this.value.phone)
        })
      }
      if (this.validName(this.value.name) != true) {
        this.errors.push({
          type: "name",
          text: this.validName(this.value.name)
        })
      }
      if (this.value.address == "" || this.value.city == "" || this.value.area == "") {
        this.errors.push({
          type: "address",
          text: this.validAddress(this.value.address, this.value.city, this.value.area)
        })
      }

      if (this.errors.length <= 0) {
        this.$emit("change-step")
      }
      else {
        document.getElementById("Checkout").scrollTo(0, 0)
      }
    },
    async GetShopList() {
      let result = await this.SendGetData(process.env.VUE_APP_BASE_API + 'shop/get_shop_list.php')
      if (result != "error") {
        let data = JSON.parse(result.data)
        this.shop_list = data
      }
    }
  },
  created() {
    this.GetShopList()
  },
  watch: {
    "form_data.city"(n, o) {
      o == "" ? "" : (this.form_data.area = "", this.form_data.address = "")
    }
  },
  computed: {
    form_data: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    },
    filter_shop_list() {
      if (this.form_data.city != "") {
        return this.shop_list.filter(item => {
          let city_test = this.CheckAddressInclude(item.address, this.form_data.city)
          let area_test = this.CheckAddressInclude(item.address, this.form_data.area)
          return city_test && area_test
        })
      }
      else {
        return []
      }
    },
    filter_city() {
      return this.city.filter(item => this.shop_list.filter(shop => this.CheckAddressInclude(shop.address, item.name)).length > 0)
    },
    filter_area() {
      if (this.form_data.city != "") {
        let tmp = this.city.filter(item => item.name == this.form_data.city)[0].area
        tmp = tmp.filter(item => {
          return this.shop_list.filter(shop => {
            let city_test = this.CheckAddressInclude(shop.address, this.form_data.city)
            let area_test = this.CheckAddressInclude(shop.address, item.name)
            return city_test && area_test
          }).length > 0
        })
        return tmp
      }
      else {
        return []
      }
    }
  }
}
</script>